import { useIntl } from "@amazeelabs/react-intl";
import React from "react";
import { useNotifications, useNotificationsStore } from "../../utils/notifications";
import { BlockMarkup } from "./PageContent/BlockMarkup";
export var MediaNotification = function() {
    var notifications = useNotifications();
    var dismiss = useNotificationsStore(function(state) {
        return state.dismiss;
    });
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, notifications.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "bg-warning-red text-white items-start md:items-center inline-flex gap-3 nested-container notification w-full justify-between md:rounded-b-xl z-50 relative py-5"
    }, /*#__PURE__*/ React.createElement("div", {
        className: " flex flex-col items-start md:flex-row gap-3 md:items-center text-sm leading-normal font-light ps-5 md:ps-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "shrink-0 max-w-[50%]"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "headline-small text-white leading-trim "
    }, notifications[0].notificationTitle)), /*#__PURE__*/ React.createElement(BlockMarkup, {
        className: " text-white",
        animationDisabled: true,
        markup: notifications[0].notificationText
    })), /*#__PURE__*/ React.createElement("button", {
        className: "h-full px-5 md:px-10 group",
        onClick: function() {
            dismiss(notifications[0].id);
        },
        "aria-label": intl.formatMessage({
            defaultMessage: "Dismiss notification",
            id: "pe7UAe"
        })
    }, /*#__PURE__*/ React.createElement(XIcon, null))));
};
var XIcon = function() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        className: "text-white group-hover:text-tcs-yellow",
        "aria-hidden": "true"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 20.322,
        height: 1.907,
        fill: "currentColor",
        rx: 0.954,
        transform: "scale(-1 1) rotate(45 -7.65 -17.51)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: 20.322,
        height: 1.907,
        fill: "currentColor",
        rx: 0.954,
        transform: "scale(1 -1) rotate(-45 -1.487 -1.014)"
    }));
};
